

export const FilterType = Object.freeze({
	multiCheckbox: "MultiCheckbox",
	range: 'Range',
});
